export const useConfiguracao = () => {
  const api = useApi();

  function obterUm(id: number){
    return api.get<{ object: Configuracao }>(`/configuracao/${id}`);
  }

  function alteracaoImagem(dat: any){
    return api.post<{ object: Configuracao }>("/configuracao/upload-brazao", dat, {headers: {'Content-Type': 'multipart/form-data' }} );
  }

  function alteracao(config: Configuracao){
    return api.put<{ object: Configuracao }>("/configuracao", config);
  }

  return { obterUm, alteracaoImagem, alteracao };
};